import React from "react";

interface PageHeaderProps {
    children: React.ReactNode
}

export default function PageHeader({children}: PageHeaderProps) {
    return (
        <div className="pageHeader-wrap">
            <div className="pageHeader">
                {children}
            </div>
        </div>
    )
}